const config = {
	apiUrl: 'https://tic-prod-2023.orbit.com.ar/api/',
	key: 'C428A377979E395725A6A1A13A0CE0D25F1B30B7DAE0EFB06F26F79EDC149472',
	GoogleKey: "AIzaSyCjux93Qrqq7XynQBa1dDMH4Ui1xcAZ6gY",
	ComisionFleteVendedor: 60,
	
}

export default config
